<template>
  <div class="body-info-cashier">
    <TopNavbar title="收银台"></TopNavbar>

    <PayCard scene="recharge"></PayCard>

    <div class="cell-box info-gap">
      <div class="box-desc">
        温馨提示
      </div>
      <div class="tip-box">
        <div>1. 本站内容为虚拟商品，一经售出不支持退款，充值所得书币，适用于阅读本站所有小说、漫画、视频等</div>
        <div>2. 充值成功的书币，不支持转让</div>
        <div>3. 半年及年费会员针对全站小说和漫画内容有效</div>
        <div>4. 若支付过程中遇到任何问题，可以联系客服解决</div>
      </div>
    </div>
  </div>
</template>

<script>
  import TopNavbar from "../common/TopNavbar";
  import {makeCallbackUrl} from "../../util/parse_params";
  import PayCard from "../common/PayCard";

  export default {
    name: "Cashier",
    components: {PayCard, TopNavbar},
    props: {
      page: {},
    },
    data() {
      return {
        creditLoading: false,
        callbackUrl: "",
      }
    },
    mounted() {
    },
    methods: {},
    computed: {}
  }
</script>

<style scoped lang="scss">

  .body-info-cashier {
    background: #f2f2f2;
    padding-top: 48px;
  }

  .cell-box {
    background: white;
    padding: 5px 4px;
    color: #2d2d2d;

    .box-desc {
      padding: 8px 5px;
    }

    .pay-logo-img {
      height: 20px;
    }

    .tip-box {
      font-size: 12px;
      color: rgba(110, 110, 110, 0.75);
      padding: 5px 12px;
      line-height: 1.8;
    }
  }

  .info-gap {
    margin-top: 5px;
  }

</style>
